export default "__VITE_ASSET__$Tf2rAhh__"